import { render, staticRenderFns } from "./MenuBar.vue?vue&type=template&id=a0222cd8&scoped=true"
import script from "./MenuBar.vue?vue&type=script&lang=js"
export * from "./MenuBar.vue?vue&type=script&lang=js"
import style0 from "./MenuBar.vue?vue&type=style&index=0&id=a0222cd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0222cd8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme1DesktopSubMenu: require('/app/components/Theme1/Desktop/SubMenu.vue').default})
